<script setup>
import { ref } from "vue";
import Badge from "./Badge.vue";
const props = defineProps({
  kind: {
    type: String,
    required: true
  },
  kindLabel: {
    type: String,
    required: true
  }
})
const kinds = ref({
  curso: "course",
  taller: "workshop",
  ruta: "list",
  recurso: "Recurso",
  premium: "premium",
  webinar: "workshop",
  masterclass: "Masterclasses",
  lab: "workshop",
  external:"C. Externo",
  blog: "Blog",
})
</script>
<template>
  <Badge :type="kinds[kind] || 'secondary'" >{{(kindLabel === 'Lista OW') ? 'Ruta' : kindLabel}}</Badge>
</template>